import { ChangeDetectionStrategy,Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { LinkifiedTextComponent } from 'app/shared/components/linkified-text.component';
import { OrderLineJobApplicationInsightsException } from 'app/shared/graph';

@Component({
    selector: 'admin-application-insights-log-details',
    imports: [
        LinkifiedTextComponent
    ],
    templateUrl: './application-insights-log-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './application-insights-log-details.component.scss'
})
export class ApplicationInsightsLogDetailsComponent implements OnChanges {
    @Input() exception!: OrderLineJobApplicationInsightsException;
    parsedException: any;
    parsedExceptionKeys: string[];

    ngOnChanges(_: SimpleChanges): void {
        try {
            this.parsedException = JSON.parse(this.exception.exceptionDetail);
            this.parsedExceptionKeys = Object.keys(this.parsedException);
        } catch (e) {
            // ignored
            this.parsedException = undefined;
            this.parsedException = [];
            console.warn(e);
        }
    }
}
